<!--
  ~ Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
  <form [formGroup]="newValueForm">

    <mat-form-field>
      <mat-label>{{ fieldLabel }}</mat-label>
      <mat-hint>{{ valueInput.value.length }}/{{ maxLength }} Characters</mat-hint>
      <input matInput #valueInput maxlength="{{maxLength}}" formControlName="newValue" id="new-value"/>
      <mat-error *ngIf="newValueForm.get('newValue').hasError('required')">
        A value is <strong>required</strong>.
      </mat-error>
    </mat-form-field>
    <br/>

    <div id="actions-container">
      <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" id="add-button" class="action-button"
              (click)="addValue()" [disabled]="!newValueForm.valid">
        {{ buttonLabel }}
      </button>
    </div>

  </form>

</div>
